import React, { useEffect, useMemo } from 'react';
import { useParams, Redirect } from 'react-router-dom';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import ClipLoader from 'react-spinners/ClipLoader';
import * as yup from 'yup';

import EnrouteForm from 'components/EnrouteForm';
import { modifyShipment, createShipment, fetchShipments} from 'state/actions/shipments';
import paths from 'pages/Router/paths';
import { useFormatMessage } from 'hooks';



const schema = yup.object().shape({
  status: yup.string().required(),
  creation: yup.string().notRequired(),
  creator: yup.string().notRequired(),
  routeDistance: yup.string().notRequired(),
  routeDuration: yup.string().notRequired(),
  pickupContactName: yup.string().notRequired(),
  pickupContactPhone: yup.string().notRequired(),
  pickupBuildingNo: yup.string().notRequired(),
  pickupStreet: yup.string().notRequired(),
  pickupAddressDescription: yup.string().notRequired(),
  pickupPostcode: yup.string().notRequired(),
  deliveryContactName: yup.string().notRequired(),
  deliveryContactPhone: yup.string().notRequired(),
  deliveryBuildingNo: yup.string().notRequired(),
  deliveryStreet: yup.string().notRequired(),
  deliveryAddressDescription: yup.string().notRequired(),
  deliveryPostcode: yup.string().notRequired(),
  startDate: yup.string().notRequired(),
  collectionHour: yup.string().notRequired(),
  collectionMinute: yup.string().notRequired(),
  urgent: yup.boolean().notRequired(),
  dedicated: yup.boolean().notRequired(),

});

const Enroute = () => {
  const { id } = useParams();

  const isEditing = useMemo(() => !!id, [id]);

  const { success, shipmentData, error } = useSelector(
    (state) => ({
      success: state.shipments.success,
      shipmentData: state.shipments.data.find((shipment) => shipment.id === id),
      error: state.shipments.error,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (isEditing) {
      if (!shipmentData) {
        dispatch(fetchShipments(id));
      }
    }
  }, [isEditing, id, shipmentData, dispatch]);

  const redirect = ((isEditing && error) || success) && (
    <Redirect to={paths.ENROUTES} />
  );

  const editShipmentMessage = useFormatMessage('Shipment.editShipment');

  const newShipmentMessage = useFormatMessage('Shipment.newShipment');

  const onSubmitHandler = (value) => {
    console.log('hello there');
    const newShipment = {
      ...value,
      isEditing,
      id,
    };

    if (isEditing) {
      dispatch(modifyShipment(newShipment));
    } else {
      dispatch(createShipment(newShipment));
    }
  };

  return (
    <>
      {redirect}
      <section className="hero is-hero-bar">
        <div className="hero-body">
          <h1 className="title">
            {isEditing ? editShipmentMessage : newShipmentMessage}
          </h1>
        </div>
      </section>
      <section className="section is-main-section">
        {isEditing && !shipmentData ? (
          <ClipLoader />
        ) : (
          <EnrouteForm
            isEditing={isEditing}
            shipment={
              isEditing
                ? shipmentData
                : {
                    name: '',
                    email: '',
                    location: '',
                    isAdmin: false,
                  }
            }
            onSubmitHandler={onSubmitHandler}
            schema={schema}
          />
        )}
      </section>
    </>
  );
};

export default Enroute;
